var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopeProfileWrite = function SvgScopeProfileWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    clipPath: "url(#scope-profile-write_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.544 12.959A2.67 2.67 0 0 1 6 11.333h2.5m-1.617 3.24A6.669 6.669 0 0 1 8 1.333a6.67 6.67 0 0 1 6.5 5.179m-3.833-.179a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0M9.117 13.95c.014-.129.021-.193.04-.253a.6.6 0 0 1 .073-.15c.035-.053.08-.099.172-.19l4.1-4.1a.878.878 0 1 1 1.24 1.242l-4.099 4.1a1.3 1.3 0 0 1-.19.171.6.6 0 0 1-.15.072c-.06.02-.124.027-.252.041L9 15z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "scope-profile-write_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgScopeProfileWrite;